
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Flex, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, useTheme } from '@chakra-ui/react';
import axios from 'axios';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import useAsyncEffect from 'use-async-effect';
import GenericHeader from '../../components/Modules/GenericHeader';
import HeadModule from '../../components/Modules/HeadModule';
import UserProfile from '../../components/User/UserProfile';
import UserSubscription from '../../components/User/UserSubscription';
import UserUtilisation from '../../components/User/UserUtilisation';
import { getProfileTabURL, STRIPE_USAGE } from '../../constants/routes';
import Plan from '../../dataModels/Plan';
import { getPlanByPriceId } from '../../utils/planHelper';
import { removeQueryParamsFromRouter } from '../../utils/queryHelper';
import { useAuth } from '../../hooks/useAuth';
import useTranslation from 'next-translate/useTranslation';
const Profile = () => {
    const router = useRouter();
    const theme = useTheme();
    const { t } = useTranslation();
    const [tabIndex, setTabIndex] = useState(0);
    const [currentPlan, setCurrentPlan] = useState<Plan>();
    const { user } = useAuth().state;
    const { data } = useSWR<{
        data: {
            priceId: string;
            currentPeriodEnd: number;
            currentUsage: number;
            userInscriptionDate: number;
        };
    }>(STRIPE_USAGE(user?.id ?? ''), axios);
    useEffect(() => {
        if (!user)
            router.replace('/profile/sign-in');
    }, []);
    useEffect(() => {
        setCurrentPlan(getPlanByPriceId(data?.data.priceId!));
    }, [data]);
    const handleTabsChange = async (index: any) => {
        setTabIndex(index);
        if (index != tabIndex) {
            await router.push(getProfileTabURL(index), undefined, { shallow: true });
        }
    };
    useEffect(() => {
        if (router.query.index) {
            setTabIndex(Number(router.query.index));
        }
    }, [router.query.index]);
    useAsyncEffect(async () => {
        const showToast = await import('../../utils/showToast').then(mod => mod.showToast);
        if (router.query?.success) {
            showToast(t('subscription:subscription_success'), 'success');
            await removeQueryParamsFromRouter(router, ['success']);
        }
        if (router.query?.canceled) {
            showToast(t('subscription:subscription_canceled'), 'error');
            await removeQueryParamsFromRouter(router, ['canceled']);
        }
        if (router.query?.['stripe-return']) {
            if (!user)
                return;
            await removeQueryParamsFromRouter(router, ['stripe-return']);
        }
    }, [router.query]);
    return (<>
      <HeadModule title='meta_title_home' description='meta_description_profile'/>
      <GenericHeader title={t('profile:user_my_account')}/>
      <Tabs index={tabIndex} onChange={handleTabsChange} mt={9}>
        <TabList m={0} p={0} gridGap={9} overflowX='scroll' w='full' className='hide-scrollbar'>
          <Tab m={0}>{t('profile:user_profile')}</Tab>
          <Tab m={0}>{t('profile:user_subscription')}</Tab>
          <Tab m={0}>{t('profile:user_usage')}</Tab>
        </TabList>
        <TabPanels w='full'>
          <TabPanel>
            <UserProfile />
          </TabPanel>
          <TabPanel>{currentPlan && <UserSubscription currentPlan={currentPlan}/>}</TabPanel>
          <TabPanel>
            {data && currentPlan ? (<UserUtilisation currentSubscriptionPeriodEnd={data?.data.currentPeriodEnd} currentSubscriptionUsage={data?.data.currentUsage} userInscriptionDate={data?.data.userInscriptionDate} currentPlan={currentPlan}/>) : (<Flex w='full' minH='10rem' p={5} borderRadius={theme.radii.big} background={theme.colors.layers.appLevel1} alignItems='center' justifyContent='center'>
                <Spinner size='md' color={theme.colors.brand.greyLight}/>
              </Flex>)}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>);
};
// noinspection JSUnusedGlobalSymbols
export default Profile;

    async function __Next_Translate__getStaticProps__19bb2fd5b10__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/profile/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5b10__ as getStaticProps }
  